// extracted by mini-css-extract-plugin
module.exports = {"scroller":"scroller___1aLqu","scroller__text":"scroller__text___7epy2","scroller__block":"scroller__block___34_wq"};
    if(module.hot) {
      // 1677682834795
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  